export default __webpack_public_path__ + "static/signature_action-a791f992256aee565e2a5afaf9e04c69.jpg";